import { Row } from '@tanstack/react-table';
import {
  HumanOperator,
  numberOperators,
  stringAndContainsOperators,
} from '../../Filters/constants';

export type TableFilter = {
  name: string;
  type: HumanOperator[];
};

export type TableFilterValue = {
  operator: HumanOperator;
  value: string;
};

export const myCustomFilter = <TData extends object>(
  row: Row<TData>,
  columnName: string,
  filterValue: TableFilterValue,
  addMeta: (meta: any) => void
): boolean => {
  const { operator, value } = filterValue;
  const rawValue = row.getValue(columnName);
  const rowValue = rawValue != null ? rawValue.toString() : '';

  if (value === null) {
    return true;
  }

  // Apply different logic based on the operator
  switch (operator) {
    case HumanOperator.Equal:
      return rowValue.toLowerCase() === value.toLowerCase();
    case HumanOperator.NotEqual:
      return rowValue.toLowerCase() !== value.toLowerCase();
    case HumanOperator.Contains: {
      return rowValue.toLowerCase().includes(value.toLowerCase());
    }
    case HumanOperator.NotContains: {
      return !rowValue.toLowerCase().includes(value.toLowerCase());
    }
    case HumanOperator.LessThan: {
      const columnValue = parseFloat(rowValue);
      const numericValue = parseFloat(value);
      if (isNaN(columnValue) || isNaN(numericValue)) return false;
      return columnValue < numericValue;
    }
    case HumanOperator.LessThanOrEqual: {
      const columnValue = parseFloat(rowValue);
      const numericValue = parseFloat(value);
      if (isNaN(columnValue) || isNaN(numericValue)) return false;
      return columnValue <= numericValue;
    }
    case HumanOperator.GreaterThan: {
      const columnValue = parseFloat(rowValue);
      const numericValue = parseFloat(value);
      if (isNaN(columnValue) || isNaN(numericValue)) return false;
      return columnValue > numericValue;
    }
    case HumanOperator.GreaterThanOrEqual: {
      const columnValue = parseFloat(rowValue);
      const numericValue = parseFloat(value);
      if (isNaN(columnValue) || isNaN(numericValue)) return false;
      return columnValue >= numericValue;
    }
    default:
      return true;
  }
};

export const getTableFilters = (filterKeys: string[]): TableFilter[] => {
  const tableFilters: TableFilter[] = [];

  const availableFilters: Record<string, HumanOperator[]> = {
    name: stringAndContainsOperators,
    imo: numberOperators,
    mmsi: numberOperators,
    callsign: stringAndContainsOperators,
    country: stringAndContainsOperators,
    'ship type': stringAndContainsOperators,
    draught: numberOperators,
    length: numberOperators,
    width: numberOperators,
  };

  filterKeys.forEach((filterKey) => {
    const keyLower = filterKey.toLowerCase();
    if (availableFilters[keyLower]) {
      tableFilters.push({ name: filterKey, type: availableFilters[keyLower] });
    }
  });

  return tableFilters;
};
